export default __webpack_public_path__ + "static/blue-background-205cb0e92d4fe527705f08184a2a77f2.webp";